import { useTranslation } from 'next-i18next'

import LeagueOptOut from '~/settings-scenario/components/LeagueOptOut'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { IUser } from '~/types/user-info-types'
import { useGetUserSettingsQuery } from '~/redux/apis/user-settings-api'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '40px' }]

export default function NotParticipating({ user }: { user: IUser | null }): React.ReactElement {
  const { t } = useTranslation('leaderboard')
  const leagueParticipation = useGetUserSettingsQuery(undefined, { skip: !user }).data?.joinLeaderboard

  return (
    <div className="flex flex-col items-center justify-center px-3">
      <div className="relative bg-black bg-opacity-80 rounded px-6 py-4 mx-4 max-w-92.5 w-full h-full flex flex-col backdrop-blur-none">
        <div className="relative z-20 flex flex-col gap-4 mb-2">
          <p className="text-lg text-center">{t('enableLeague')}</p>
          {typeof leagueParticipation === 'boolean' && (
            <LeagueOptOut hasPadding leagueParticipation={leagueParticipation} />
          )}
        </div>
        <div className="absolute z-10 inset-0 overflow-hidden" style={{ borderRadius: '11' }}>
          <svg height="100%" width="100%">
            <defs>
              <linearGradient id="grad" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#9F7CFF" />
                <stop offset="100%" stopColor="#7945FF" />
              </linearGradient>
            </defs>
            <rect fill="transparent" height="100%" rx={11} stroke="url(#grad)" strokeWidth="4" width="100%" />
          </svg>
        </div>
      </div>
      {user?.id && (
        <div className="pt-16" style={{ maxWidth: 'calc(100vw - 24px)' }}>
          <p>{t('unranked')}</p>

          <div className="flex items-center p-2 gap-4 w-full">
            <ResponsiveImage
              alt="avatar"
              height={40}
              imageClassName="rounded-full"
              imageWidths="40"
              mediaQuery={mediaQuery}
              srcKey={user?.avatarPngUrl ? user?.avatarPngUrl : 'avatar-portraits/hom-default-avatar.png'}
              width={40}
            />
            <p className="flex-shrink overflow-ellipsis overflow-hidden max-w-[225px] whitespace-nowrap">
              {user?.nickname}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
